<template lang="pug">
  .box
    .blockOne
      .oneHeader
        h3 产品概述
        .blue
      .oneBody
        img(src="../../assets/images/document/d1.jpg" alt="")
        .pBox
          p <span>速云公文管理系统</span>是一套通过发文拟稿，收文登记和签报拟稿等功能相结合的综合公文管理系统。系统结合国内政府机关及企业的实际情况，内容科学、全面而实用；简捷的操作面板，美观的录入窗口，快捷的查询功能，强大的数据统计功能等。操作快捷、方便、易懂、易会；解决公文处理的连续性和全面性， 实现对公文处理和管理的全过程，推动公文管理“快、 简、省、高“，改变公文办理的低效和弊端，大幅度地提高公文管理工作效率，使公文管理步入系统化、现代化和科学化的轨道。
    .blockTwo
      .twoHeader
        h3 产品架构
        .blue
      .twoBody
        img(src="../../assets/images/document/d2.jpg" alt="")
    .blockOne
      .oneHeader
        h3 功能介绍
        .blue
      .oneBody
        .one
          h3 1. 公文管理-个人中心
          img(src="../../assets/images/document/d3.jpg" alt="" style="width:25%;")
          img(src="../../assets/images/document/d4.jpg" alt="" style="width:75%;")
          p ”速云“公文管理系统首页个人中心“经办文件”、“待阅文件”、“来文接收”、“我发起的”等常用办理文件分类显示，避免重要文件遗漏、混淆。包含我的发文/收文/签报文件，已办待办状态一目了然，进一步提高了公文效率、提升了无纸化办公的程度。
        .two
          h3 2. 发文管理流程图
          img(src="../../assets/images/document/d5.jpg" alt="")
        .three
          h3 3. 发文管理
          p 发文管理包括拟稿、核稿、会稿、审稿、签发、编号、套红、签章、打印、分发、传阅等环节，单位在实际使用中需要结合流程流转中附加选型给予各个节点相应的权限去控制发文处理过程。支持各类公文流转场景，实现填写意见、督办、转办、套红、编号、盖章、流转跟踪、公文催办等功能应用。
          img(src="../../assets/images/document/d6.jpg" alt="" style="width:80%;")
          img(src="../../assets/images/document/d7.jpg" alt="" style="width:20%;")
        .one
          h3(style="text-align:right;") 4. 收文管理-收文登记
          img(src="../../assets/images/document/d8.jpg" alt="" style="width:23%;")
          img(src="../../assets/images/document/d9.jpg" alt="" style="width:77%;")
          p 支持对收文办理全过程管理，包括签收、登记、分发、传阅、批注、上报等环节，实现移动化收文的登记。
        .one
          h3 5. 收文管理-收文分发/传阅
          img(src="../../assets/images/document/d10.jpg" alt="" style="width:25%;")
          img(src="../../assets/images/document/d11.jpg" alt="" style="width:75%;")
          p 来文签收、登记完成后，正文内容加截快，体验好，在线附件编辑、批注等轻松自如，领导下基层调研、外地公务出差，均可快速办文。
          p 在线分发、传阅，可直接从组织架构中选择对应部门和人员。
        .one
          h3(style="text-align:right;") 6. 智能统计
          img(src="../../assets/images/document/d12.jpg" alt="" style="width:23%;")
          img(src="../../assets/images/document/d13.jpg" alt="" style="width:77%;")
          p 数据信息按季度/类型/单位/状态自动统计公文发布数量，支持柱状图、折线图、饼状图等多种图表样式，实现各项统计报表一键生成导出，提供智能和决策分析,实现公文管理制度化、规范化、信息化，让公文管理工作智慧起来。
    .blockTwo(style="margin-bottom:0;")
      .twoHeader
        h3 安全支持
        .blue
      .twoBody
        h3 全链路安全技术保障企业信息安全
        ul
          li
            .pBox
              h3 1. 独立安全审计
              p 国内首家通过SOC2隐私性原则审计，安全性，保密性和隐私性三项原则审计。
          li
            .pBox
              h3 2. 安全体系认证
              p 通过ISO27001:2013 ISO27018:2014，安全认证体系的企业级应用产品。
          li
            .pBox
              h3 3. 三级等级保护
              p 通过由公安部监制，由属地公安机关认可并颁发的国家级信息 系统等级认证。
          li
            .pBox
              h3 4. 企业密钥
              p 数据享受国密级别安全保护。
        img(src="../../assets/images/document/d14.jpg" alt="" style="width:70%;float:left;")
        img(src="../../assets/images/document/d15.jpg" alt="" style="width:30%;float:left;")
</template>

<script>
export default {
  data () {
    return {}
  },
  created () {
    this.$store.commit('changeNavOther', 5)
  }
}
</script>

<style lang="less" scoped>
  .blockOne{
    width: 70%;
    margin: 0 auto 68px;
    .oneHeader{
      font-size: 20px;
      padding-bottom: 30px;
      h3{
        font-weight: 400;
      }
      .blue{
        float: left;
        width: 35px;
        height: 3px;
        background-color: #409fee;
        margin-top: 10px;
      }
    }
    .oneBody{
      text-align: justify;
      overflow: hidden;
      img{
        float: left;
        width: 35%;
        vertical-align: middle;
      }
      .pBox{
        float: right;
        width: 60%;
        border-radius: 10px;
        border: 2px solid red;
        padding: 10px;
        margin-top: 30px;
        p{
          line-height: 26px;
          text-indent: 2em;
          span{
            font-size: 20px;
            color: red;
          }
        }
      }
      .one{
        overflow: hidden;
        h3{
          font-weight: 400;
          margin: 10px 0;
        }
        img{
          float: left;
        }
        p{
          float: left;
          width: 73%;
          line-height: 26px;
          text-indent: 2em;
          margin: 10px 0 0 10px;
        }
      }
      .two{
        overflow: hidden;
        h3{
          text-align: right;
          font-weight: 400;
          margin: 10px 0;
        }
        img{
          display: block;
          width: 90%;
          margin: 30px auto;
          float: none;
        }
      }
      .three{
        overflow: hidden;
        h3{
          font-weight: 400;
          margin: 10px 0;
        }
        p{
          text-indent: 2em;
          line-height: 26px;
          margin-top: 20px;
        }
      }
    }
  }
  .blockTwo{
    padding: 0 15% 20px;
    background-color: #f9f9f9;
    margin-bottom: 20px;
    .twoHeader{
      font-size: 20px;
      padding: 30px 0;
      h3{
        font-weight: 400;
        text-align: right;
      }
      .blue{
        float: right;
        width: 35px;
        height: 3px;
        background-color: #409fee;
        margin-top: 10px;
      }
    }
    .twoBody{
      overflow: hidden;
      img{
        display: block;
        width: 70%;
        margin: 0 auto;
      }
      h3{
        font-size: 18px;
        font-weight: 400;
        margin: 10px 0;
      }
      ul{
        overflow: hidden;
        li{
          float: left;
          width: 50%;
          .pBox{
            width: 60%;
            margin: 0 auto;
            border-radius: 10px;
            border: 1px dashed #ccc;
            padding: 10px;
            margin-bottom: 10px;
            height: 90px;
          }
          h3{
            font-size: 16px;
            text-align: center;
          }
          p{
            font-size: 14px;
            text-indent: 2em;
            line-height: 24px;
          }
        }
      }
    }
  }
</style>
